module.exports = __webpack_public_path__ + "img/20200515_160918.7b00940b.jpg";